import { gql } from '@apollo/client';

export const SUBMIT_ISSUE_REPORT_MUTATION = gql`
  mutation SubmitIssueReport($input: SubmitIssueReportInput!) {
    submitIssueReport(input: $input) {
      success
    }
  }
`; 